import { Car } from "lucide-react";
import SeoLanding from "@/components/site/SeoLanding";

export default function PermisBoiteManuelle() {
  return (
    <SeoLanding
      testId="page-boite-manuelle"
      seo={{
        title: "Permis boîte manuelle Boulogne-Billancourt · 999 € | DDSBillancourt",
        description: "Permis B boîte manuelle à Boulogne-Billancourt : 20 leçons + 2 offertes + simulateur à 999 €. Moniteurs expérimentés, conduite 7j/7 de 7h à 22h, zones d'examen intégrées dès les premières leçons.",
        path: "/permis-boite-manuelle",
      }}
      breadcrumbName="Permis boîte manuelle"
      badge="Permis B · Boîte manuelle"
      badgeIcon={Car}
      h1="Permis boîte manuelle à Boulogne-Billancourt"
      intro={[
        "Le permis B en boîte manuelle reste le permis le plus polyvalent : il vous permet de conduire tous les véhicules, manuels comme automatiques, partout en France et à l'étranger.",
        "DDSBillancourt, auto-école agréée à Boulogne-Billancourt (92100), vous forme avec des moniteurs expérimentés, un livret d'apprentissage, un simulateur de conduite et une plateforme de code en ligne illimitée. Note Google : 5,0/5 sur plus de 100 avis.",
      ]}
      formules={[
        {
          name: "20 leçons + 2 offertes (auto & manuelle)",
          price: "999 €",
          priceNum: 999,
          highlight: true,
          features: ["20 leçons de conduite + 2 offertes", "Boîte manuelle et boîte automatique", "Simulateur de conduite", "Livret d'apprentissage", "Paiement en plusieurs fois"],
        },
        {
          name: "30 leçons (auto & manuelle)",
          price: "1 349 €",
          priceNum: 1349,
          features: ["30 leçons de conduite", "Plus de pratique pour les débutants", "Simulateur inclus", "Livret d'apprentissage"],
        },
      ]}
      sections={[
        {
          title: "Pourquoi choisir la boîte manuelle ?",
          bullets: [
            { title: "Un permis sans restriction", text: "vous pourrez conduire n'importe quel véhicule : voiture de location, utilitaire, véhicule de fonction, voiture d'occasion." },
            { title: "Un atout professionnel", text: "de nombreux employeurs (livraison, BTP, commerce) exigent le permis B « complet » en boîte manuelle." },
            { title: "La maîtrise totale du véhicule", text: "embrayage, rétrogradage, frein moteur : des compétences précieuses en montagne ou sur route glissante." },
          ],
        },
        {
          title: "Notre méthode : progresser vite, sans stress",
          paragraphs: [
            "Chaque élève est suivi par un moniteur référent qui adapte le programme à son rythme. Les compétences délicates — démarrage en côte, créneaux, insertion sur voie rapide — sont d'abord travaillées sur notre simulateur nouvelle génération, puis consolidées sur route.",
            "Les leçons durent 55 minutes de conduite effective, suivies de 5 minutes de bilan personnalisé. Dès les premières heures, vous conduisez sur les zones d'examen réelles : Boulogne-Billancourt, Porte de Saint-Cloud, Porte d'Auteuil et Place d'Italie.",
          ],
        },
        {
          title: "Horaires étendus : conduisez quand vous êtes disponible",
          paragraphs: [
            "Nous sommes l'une des rares auto-écoles de Boulogne-Billancourt à proposer des leçons 7 jours sur 7 : de 7h à 22h du lundi au samedi, et de 10h à 20h le dimanche. Tôt le matin avant les cours, tard le soir après le travail ou le week-end : votre formation avance sans bouleverser votre emploi du temps.",
          ],
        },
      ]}
      faq={[
        { q: "Combien d'heures faut-il pour le permis boîte manuelle ?", a: "Le minimum légal est de 20 heures. La moyenne nationale se situe autour de 25 à 30 heures selon le niveau de départ. Notre formule 20 leçons + 2 offertes couvre le parcours type ; la formule 30 leçons convient aux grands débutants." },
        { q: "Le code est-il inclus dans la formule à 999 € ?", a: "Oui : l'accès à notre plateforme de code de la route en ligne (cours illimités + quiz) est compris dans la formule 20 leçons + 2 offertes." },
        { q: "Puis-je payer en plusieurs fois ?", a: "Oui, toutes nos formules sont payables en plusieurs fois (jusqu'à 4 fois), sans dossier compliqué." },
        { q: "J'ai raté mon examen dans une autre auto-école, pouvez-vous me reprendre ?", a: "Bien sûr. Avec votre numéro NEPH, l'inscription se fait à tout moment. Une heure d'évaluation permet de définir le nombre d'heures réellement nécessaire — pas de forfait imposé." },
        { q: "Proposez-vous des formations accélérées en boîte manuelle ?", a: "Oui : formules intensives 13h, 20h et 30h pour être présenté à l'examen en quelques semaines. Voir notre page formations accélérées." },
      ]}
      crossLinks={[
        { to: "/permis-boite-automatique", label: "Permis boîte automatique" },
        { to: "/conduite-accompagnee", label: "Conduite accompagnée (AAC)" },
        { to: "/accelere", label: "Formations accélérées" },
        { to: "/code-de-la-route", label: "Code de la route" },
        { to: "/moto", label: "Permis moto" },
      ]}
    />
  );
}
